// import

import * as Sentry from '@sentry/nextjs';
import {Integrations} from '@sentry/tracing';
import {isProd} from '@sitearcade/is-env';

import {getLogRocketSession} from 'libs/tracking';

// config

Sentry.init({
  enabled: isProd,
  dsn: process.env.SENTRY_DSN,
  sampleRate: isProd ? 1 : 0.5,
  tracesSampleRate: isProd ? 1 : 0.5,

  integrations: [
    new Integrations.BrowserTracing({
      tracingOrigins: [
        'localhost',
        /(([\w-]+\.)*)sitearcade\.com/,
        /^\//,
      ],
    }),
  ],

  beforeSend(event) {
    event.extra ??= {};
    event.extra.logRocketUrl = getLogRocketSession();

    return event;
  },
});

getLogRocketSession((url) => {
  Sentry.configureScope((scope) => {
    scope.setExtra('logRocketUrl', url);
  });
});
